<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="基地"
        prop="baseId"
      >
        <a-select
          v-model="form.baseId"
          placeholder="请选择基地"
          allow-clear
          show-search
          :filter-option="filterOption"
          @select="selectBase"
        >
          <a-select-option
            v-for="item in baseOptions"
            :key="item.baseId"
            :value="item.baseId"
          >
            {{ item.baseName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="回款金额"
        prop="collectionAmount"
      >
        <a-input-number
          v-model="form.collectionAmount"
          style="width: 100%;"
          :min="0"
          placeholder="请输入回款金额"
        />
      </a-form-model-item>
      <a-form-model-item
        label="回款时间"
        prop="collectionDate"
      >
        <a-date-picker
          v-model="form.collectionDate"
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item
        label="运营年度"
        prop="operateYear"
      >
        <a-select
          v-model="form.operateYear"
          placeholder="请选择运营年度"
          allow-clear
        >
          <a-select-option
            v-for="item in operatorYearsOptions"
            :key="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateCollection, addCollection } from '@/api/paymentRecord.js'
import { queryOperatorYears } from '@/api/common.js'
import { filterOption } from '@/utils/utils.js'

import moment from 'moment'
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    baseOptions: {
      type: Array,
      default: null
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: undefined,
        collectionAmount: undefined,
        collectionDate: null,
        operateYear: undefined
      },
      validateRules: {
        baseId: [{ required: true, message: '请选择基地' }],
        collectionAmount: [{ required: true, message: '请输入回款金额' }],
        collectionDate: [{ required: true, message: '请选择回款时间' }],
        operateYear: [{ required: true, message: '请选择运营年度' }]
      },
      operatorYearsOptions: []
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.initData.collectionDate =
        this.initData.collectionDate
          ? moment(this.initData.collectionDate).format('YYYY-MM-DD')
          : null
          Object.assign(this.form, this.initData)
          if (this.form.baseId) {
            this.selectBase()
          }
        }
      }
    }
  },
  methods: {
    moment,
    filterOption,
    selectBase () {
      queryOperatorYears({
        baseId: this.form.baseId
      }).then((data) => {
        this.operatorYearsOptions = data
      })
    },
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    handleOk () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.actionType === '0') {
            updateCollection({
              ...this.form,
              collectionDate: moment(this.form.collectionDate).valueOf()
            })
              .then(() => {
                this.$message.success('提交成功!')
                this.$emit('ok')
              })
          } else {
            addCollection({
              ...this.form,
              collectionDate: moment(this.form.collectionDate).valueOf()
            })
              .then(() => {
                this.$message.success('提交成功!')
                this.$emit('ok')
              })
          }
        }
      })
    }
  }
}
</script>
